/**
 * The signed-in user's id, published by `AuthProvider` on its own small
 * context so per-user data hooks can key what they hold in memory without
 * importing the whole auth module (and without `useAuth()`'s throw when a
 * hook is rendered outside the provider, e.g. in an isolated hook test).
 *
 * `null` means "no signed-in user known here" — a consumer must treat that
 * as "do not cache anything", never as a shared anonymous bucket.
 */
import * as React from 'react';

export const SignedInUserIdContext = React.createContext<string | null>(null);

export function useSignedInUserId(): string | null {
  return React.useContext(SignedInUserIdContext);
}
